import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { 
  Home, 
  FileText, 
  BarChart3,
  Plus,
  LogOut
} from 'lucide-react';

const MobileBottomNav = () => {
  const location = useLocation();
  const { signOut } = useAuth();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/',
      active: location.pathname === '/'
    },
    {
      id: 'projects',
      label: 'โปรเจค',
      icon: FileText,
      path: '/projects',
      active: location.pathname.startsWith('/projects') && !location.pathname.includes('/new') && !location.pathname.includes('/edit')
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: BarChart3,
      path: '/analytics',
      active: location.pathname === '/analytics'
    },
    {
      id: 'new-project',
      label: 'เพิ่ม',
      icon: Plus,
      path: '/projects/new',
      active: location.pathname === '/projects/new'
    },
    {
      id: 'logout',
      label: 'ออก',
      icon: LogOut,
      path: '/logout',
      active: false,
      isLogout: true
    }
  ];

  const handleNavigation = (item) => {
    if (item.isLogout) {
      setShowLogoutDialog(true);
    } else {
      window.location.href = item.path;
    }
  };

  const handleLogout = async () => {
    await signOut();
    window.location.href = '/login';
  };

  // All items are visible
  const visibleItems = navItems;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="flex items-center justify-around py-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item)}
              className={cn(
                "flex flex-col items-center justify-center py-2 px-3 rounded-lg transition-colors duration-200 min-w-0 flex-1",
                item.active
                  ? "text-blue-600 bg-blue-50"
                  : item.isLogout
                  ? "text-red-600 hover:text-red-700 hover:bg-red-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              )}
            >
              <Icon className={cn(
                "h-5 w-5 mb-1",
                item.active ? "text-blue-600" : item.isLogout ? "text-red-600" : "text-gray-500"
              )} />
              <span className={cn(
                "text-xs font-medium truncate",
                item.active ? "text-blue-600" : item.isLogout ? "text-red-600" : "text-gray-500"
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Logout Confirmation Dialog */}
      <Dialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>ยืนยันการออกจากระบบ</DialogTitle>
            <DialogDescription>
              คุณต้องการออกจากระบบหรือไม่? การดำเนินการนี้จะทำให้คุณต้องเข้าสู่ระบบใหม่
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setShowLogoutDialog(false)}
            >
              ยกเลิก
            </Button>
            <Button
              variant="destructive"
              onClick={handleLogout}
            >
              ออกจากระบบ
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MobileBottomNav;
